export default __webpack_public_path__ + "static/media/DavidArnold.004ef3b2.jpg";